export enum ConflictActionType {
    Attack = 'attack',
    Ability = 'ability',
    Item = 'item',
    Flee = 'flee',
}
